/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResourceTypeDto } from '../models/ResourceTypeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ResourceTypeControllerService {
    /**
     * @param uuid
     * @returns ResourceTypeDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<ResourceTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource-types/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ResourceTypeDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ResourceTypeDto,
    ): CancelablePromise<ResourceTypeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/resource-types/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/resource-types/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns ResourceTypeDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<ResourceTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource-types',
        });
    }
    /**
     * @param requestBody
     * @returns ResourceTypeDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ResourceTypeDto,
    ): CancelablePromise<ResourceTypeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resource-types',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param category
     * @returns ResourceTypeDto OK
     * @throws ApiError
     */
    public static findByCategory(
        category: string,
    ): CancelablePromise<Array<ResourceTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource-types/by-category',
            query: {
                'category': category,
            },
        });
    }
}
